var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getPageData as getPageDataWithPlatform, } from "./getPageData";
import { createPlatform } from "./platform";
import { getResponsiveLayout } from "./responsiveLayout";
import { getNativeClient } from "./nativeClient";
export var getPageData = function (data
// eslint-disable-next-line @typescript-eslint/ban-types
) { return function () {
    return getPageDataWithPlatform(__assign(__assign({}, data), { platform: createPlatform({
            nativeClient: getNativeClient(window.location.search),
            responsiveLayout: getResponsiveLayout(window.innerWidth),
        }), responsiveLayout: getResponsiveLayout(window.innerWidth) }))();
}; };
//# sourceMappingURL=browserDecorator.js.map